export default __webpack_public_path__ + "static/media/guardofdancingsteel1.1aaeb89f.png";